import SearchIcon from "@mui/icons-material/Search";
import Box from "@mui/material/Box";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import _ from "lodash";
import { memo, useCallback, useEffect, useMemo, useState } from "react";
import { createSearchParams, useNavigate } from "react-router-dom";
import { FILTERS_BORDER_COLOR, SEARCH_ICON_COLOR } from "styles/colors";
import useDebounce from "utils/hooks/useDebounceValue";
import useQueryParams from "utils/hooks/useQueryParams";

function UserSearch() {
  const params = useQueryParams();
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState("");
  const deferredValue = useDebounce(searchValue, 700);

  const handleChange = useCallback((value) => {
    return setSearchValue(value.trim());
  }, []);

  const _params = useMemo(() => {
    let _params = { ...params };
    if (deferredValue) {
      _params.fullname = deferredValue;
    } else {
      _params = _.omit(params, ["fullname"]);
    }
    return _params;
  }, [deferredValue, params]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      navigate({
        search: createSearchParams(_params).toString(),
      });
    }, 100);
    return () => clearTimeout(timeout);
  }, [_params, deferredValue, navigate, params]);

  return (
    <Box sx={containerStyles}>
      <TextField
        id="outlined-search"
        label="Search"
        type="search"
        size="small"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ color: SEARCH_ICON_COLOR }} />
            </InputAdornment>
          ),
        }}
        onChange={(e) => {
          handleChange(e.target.value);
        }}
      />
    </Box>
  );
}

export default memo(UserSearch);

const containerStyles = {
  textAlign: "end",
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: FILTERS_BORDER_COLOR,
      borderRadius: "20px",
    },
    "&:hover": {
      backgroundColor: "#edf8fd",
      "& fieldset": {
        borderColor: FILTERS_BORDER_COLOR,
      },
    },
  },
  "&:hover": {
    "& fieldset": {
      borderColor: FILTERS_BORDER_COLOR,
    },
  },
};
